module.exports = __webpack_public_path__ + "img/applicantsicon.31aa3b5c.svg";